export default __webpack_public_path__ + "static/media/Ending_BGM.13c09ef4.wav";